module.exports = __webpack_public_path__ + "static/img/01.c8ceb2b1.png";